import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-user-tag',
  imports: [],
  templateUrl: './icon-bold-user-tag.html',
  styleUrl: './icon-bold-user-tag.css'
})
export class IconBoldUserTag {
@Input() color = 'black';
@Input() size = '24'
}
